import React, { useState } from 'react';
import { clickEventHandler } from '@/helpers';
import { COMPONENT_TYPE, EVENT_TYPE } from '@/const';
import { BoxTabButton } from '@/components/molecules';
import { TabList, Wrapper } from '@/components/organisms/buttonTab/ButtonTab.styled';
import { ITabList } from '@/types';
import useIsomorphicEffect from '@/hooks/useIsomorphicEffect';
import { useCommonParams } from '@/hooks';

const ButtonTab = (props: ITabList) => {
  const { categories, onClick, isSpread = false } = props;
  const [nowIndex, setNowIndex] = useState(0);
  const isomorphicEffect = useIsomorphicEffect();
  const commonParams = useCommonParams();

  const handleClick = async (index: number, item: any) => {
    if (nowIndex === index) return;
    setNowIndex(index);
    await clickEventHandler({
      ...commonParams,
      componentName: COMPONENT_TYPE.CATEGORY,
      creativeDtlSeq: item.creativeDtlSeq,
      creativeDtlType: 'CF',
      clickType: EVENT_TYPE.CLICK.CATEGORY,
      destinationType: 'D',
      codeNm: item.code,
    });
    await onClick(item.code);
  };

  isomorphicEffect(() => {
    setNowIndex(0);
  }, [commonParams.page]);

  return (
    <Wrapper>
      <TabList role="tab-list" isSpread={isSpread}>
        {categories &&
          categories.map((item, index) => (
            <BoxTabButton
              key={index}
              onClick={() => handleClick(index, item)}
              isActive={nowIndex === index}
            >
              {item.codeNm}
            </BoxTabButton>
          ))}
      </TabList>
    </Wrapper>
  );
};

export default ButtonTab;
